var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',{staticClass:"material"},[_c('VueMarkdown',{attrs:{"source":_vm.material,"breaks":false},on:{"rendered":_vm.postProcess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }